import apiWorker from '../apiWorker'

const review_outcomes = {
    create : (data) => apiWorker('post', `/v1/reviews/outcomes`, data, true),
}

export default review_outcomes;